/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;align-items:center;position:relative}.progress-background[_ngcontent-%COMP%]{height:14px;width:100%}@media (min-width:768px){.progress-background[_ngcontent-%COMP%]{height:18px}}.progress-bar[_ngcontent-%COMP%]{height:14px}@media (min-width:768px){.progress-bar[_ngcontent-%COMP%]{height:18px}}"];
export { styles as styles };
